"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OfflineConfigManager_1 = __importDefault(require("@amzn/amazon-config-store-type-script-offline-adapter/dist/OfflineConfigManager"));
/**
 * Singleton class to provide access to the ACS Offline Configuration Manager
 * to be used to create ACS clients.
 */
class OfflineConfigManagerHolder {
    constructor() { }
    /**
     * @return the instance of ACS Configuration manager.
     */
    static get() {
        return this.CONFIG_MANAGER;
    }
}
exports.default = OfflineConfigManagerHolder;
OfflineConfigManagerHolder.CONFIG_MANAGER = new OfflineConfigManager_1.default();
//# sourceMappingURL=offline-config-manager-holder.js.map